import React from 'react';

import { Svg } from '../Svg/Svg';

import classes from './ProductTrustMessage.scss';

export const freeReturns = (
    <p className={classes.root}>
        <Svg name="returns" /> Free & Easy Returns for up to 30 days
    </p>
);

export const freeShipping = (
    <p className={classes.label}>
        <Svg name="delivery" /> <b>Free delivery</b> available on this item
    </p>
);
